// extracted by mini-css-extract-plugin
export default {"h1":"WhatIs_h1__BAo0p","mainContainer":"WhatIs_mainContainer__eCsQ6","h2":"WhatIs_h2__+oc98","h3":"WhatIs_h3__9gCPN","p":"WhatIs_p__n9jMg"};